import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DatastoreService } from './datastore.service';

export interface BasketTimerState {
	end: number;
	extended: boolean;
}

/**
 * Holds the end time of the basket countdown. The state is in sessionStorage,
 * so a page refresh keeps the time that is left.
 */
@Injectable({ providedIn: 'root' })
export class BasketTimerService {
	static readonly MINUTES = 35;
	private readonly key = 'basket_timer';
	private readonly pages = ['/booking-details', '/summary'];

	constructor(private router: Router, private datastoreService: DatastoreService) {}

	start(extended = false): void {
		const state: BasketTimerState = { end: Date.now() + BasketTimerService.MINUTES * 60000, extended };
		sessionStorage.setItem(this.key, JSON.stringify(state));
	}

	stop(): void {
		sessionStorage.removeItem(this.key);
	}

	get state(): BasketTimerState | null {
		try {
			return JSON.parse(sessionStorage.getItem(this.key));
		} catch {
			return null;
		}
	}

	/** Customer journey only: staff on the admin journey do not see the timer. */
	get showing(): boolean {
		return (
			!!this.state &&
			!this.datastoreService.adminJourney &&
			this.pages.some((page) => this.router.url.startsWith(page))
		);
	}
}
